import { instanceFetch } from '../../fetch';
import { LocalStorageService } from '../../helper';

export const serviceSignup = (body, callbackSuccess, callbackFailure) => {
  let referalId;
  if (LocalStorageService.get('referral_user_id'))
    referalId = `?referral_user_id=${LocalStorageService.get('referral_user_id')}`;
  if (LocalStorageService.get('aff_id'))
    referalId = `?affise_pid=${LocalStorageService.get('aff_id')}`;
  return instanceFetch
    .post(`/users/register${referalId ?? ''}`, body)
    .then((data) =>
      callbackSuccess({
        text: data.message,
      })
    )
    .catch(({ details }) => {
      callbackFailure({
        text: details,
        color: 'red',
      });
    });
};
